import {Injectable} from '@angular/core';

export type MrzFields = Record<string, any>;

@Injectable({ providedIn: 'root' })
export class MrzFieldsService {

  private success = false;
  private fields: MrzFields | null = null;

  set(fields: MrzFields): void {
    this.fields = fields;
  }

  consume(): MrzFields | null {
    const current = this.fields;
    this.fields = null;
    return current;
  }

  setSuccess(success: boolean): void {
    this.success = success;
  }

  isSuccess(): boolean {
    return this.success;
  }

  peek(): MrzFields | null {
    return this.fields;
  }

  clear(): void {
    this.fields = null;
  }
}
